import { render, staticRenderFns } from "./Analyzes.vue?vue&type=template&id=040235a8&"
import script from "./Analyzes.vue?vue&type=script&lang=js&"
export * from "./Analyzes.vue?vue&type=script&lang=js&"
import style0 from "./Analyzes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports